import './Footer.css';
import {useNavigate} from "react-router-dom";

export default function Footer() {
    const navigate = useNavigate();

    return <div id='footer'>
        <div id='footer-top'>

            <div className='footer-section' id='footer-section-info'>
                <span className='footer-section-label'>INFORMACJE</span>
                <span onClick={()=>navigate('/polityka')}>POLITYKA PRYWATNOŚCI</span>
                <span onClick={()=>navigate('/regulamin')}>REGULAMIN</span>
                <span onClick={()=>navigate('/ciasteczka')}>POLITYKA COOKIES</span>

            </div>
            <div className='footer-section' id='footer-section-about'>
                <span className='footer-section-label' id='footer-section-about-label'>LUME STORE</span>
                <div id='footer-section-about-bottom'>
               <div id='footer-section-about-left'>

                   <div className='footer-about-section'>
                       <img src="/images/address-icon.png" alt=""/>
                       <span>Pograniczna 13, Garlica Murowana, <br></br>32-087, Polska</span>
                   </div>
                   <div className='footer-about-section'>
                       <img src="/images/mail-icon.png" alt=""/>
                       <span>kontakt@lumestore.pl</span>
                   </div>
                   <div className='footer-about-section'>
                       <img src="/images/nip-icon.png" alt=""/>
                       <span>NIP:  5130301837</span>
                   </div>
               </div>
                <div id='footer-section-about-right'>
                    {/*<div className='footer-about-section'>*/}
                    {/*    <img src="/images/clock-icon.png" alt=""/>*/}
                    {/*    <span>Poniedziałek-Piątek 9:00-17:00</span>*/}
                    {/*</div>*/}
                    {/*<div className='footer-about-section'>*/}
                    {/*    <img src="/images/phone-icon.png" alt=""/>*/}
                    {/*    <span>+48 111 111 111</span>*/}
                    {/*</div>*/}
                </div>
                </div>
            </div>
        </div>
        <div id='footer-bottom'>

        </div>
    </div>;
}
